/* global gsap */

/**
 * floatingAnimation path animation
 * @param {Element} element - element to animate
 */
function floatingAnimation(element) {
  // initial values
  gsap.set('.floating-box', {drawSVG: '0%'});
  gsap.set(element, {opacity: '0'});
  gsap.set('.floating-box--a', {y: '10px'});
  gsap.set('.floating-box--b', {y: '10px'});
  gsap.set('.floating-box--b', {y: '7px'});

  // fade in entire SVG
  gsap.to(element, {
    scrollTrigger: {
      trigger: element,
      start: '-100px 48%',
    },
    opacity: 1,
  });

  // Line drawn animation
  gsap.to('.floating-box', {
    scrollTrigger: {
      trigger: element,
      start: '-100px 50%',
      end: '300px 10%',
    },
    drawSVG: '100%',
    duration: 1,
    ease: 'Sine.easeOut',
  });


  // Hover animation for specific box groups
  gsap.to('.floating-box--a', {
    scrollTrigger: {
      trigger: element,
      start: 'top 60%',
    },
    y: '-20px',
    yoyo: true,
    repeat: -1,
    duration: 4,
    ease: 'linear',
  });

  gsap.to('.floating-box--b', {
    scrollTrigger: {
      trigger: element,
      start: 'top 60%',
    },
    y: '-=-40px',
    yoyo: true,
    repeat: -1,
    duration: 4,
    ease: 'linear',
  });

  gsap.to('.floating-box--c', {
    scrollTrigger: {
      trigger: element,
      start: 'top 60%',
    },
    y: '-=-40px',
    yoyo: true,
    repeat: -1,
    duration: 4.1,
    ease: 'linear',
  });

  gsap.to('.floating-box--d', {
    scrollTrigger: {
      trigger: element,
      start: 'top 60%',
    },
    y: '-5px',
    yoyo: true,
    repeat: -1,
    duration: 3,
    ease: 'linear',
  });

  // exit scale and fade out animation
  gsap.to(element, {
    immediateRender: false,
    scrollTrigger: {
      trigger: element,
      start: 'bottom 30%',
      scrub: 1,
    },
    scale: 1.3,
    yPercent: -10,
    opacity: 0,
    transformOrigin: '50% 50%',
  });
}

export {floatingAnimation};
